// extracted by mini-css-extract-plugin
module.exports = {"header":"search_header__V2BTJ","form":"search_form__42R4e","input":"search_input____K97","tagContainer":"search_tagContainer__NUwRu","tag":"search_tag__b6Asd"};